import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuButton,
  MenuList,
  Icon,
  Flex,
  Text,
} from "@chakra-ui/react";
import { FaCaretDown } from "react-icons/fa6";
import {
  newBorder,
  textSecondary,
  white,
  backgroundLight,
  primary,
  primaryAlt,
  textPrimary,
} from "../../utils/colors";
import { shade } from "polished";

const DropdownButtonTitle = ({
  initialLabel,
  items,
  onSelectItem,
  iconComponent,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(initialLabel);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const handleMenuItemClick = (item) => {
    onSelectItem(item);
    setSelectedLabel(item); // Update the label with the selected item
    setIsOpen(false);
  };

  useEffect(() => {
    setSelectedLabel(initialLabel);
  }, [initialLabel]);

  // console.log("initialLabel", initialLabel);
  // console.log("selectedLabel", selectedLabel);

  return (
    <Box p={0} borderRadius="0.75rem">
      <Menu isLazy onOpen={handleMenuOpen} onClose={handleMenuClose}>
        <MenuButton
          as={Button}
          bg="transparent"
          color={textPrimary}
          border={`0px solid ${newBorder}`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="10.75rem"
          size="sm"
          p="0rem 0rem"
          // position="relative"
          // top="0.25rem"
          transition="0.2s all"
          _hover={{ bg: primaryAlt }}
          _active={{ bg: primaryAlt }}
          cursor="pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Flex align="center">
            {iconComponent && <Box mr={2}>{iconComponent}</Box>}
            <Text fontSize="1.125rem" fontWeight="600">
              {selectedLabel}
            </Text>
            <Icon
              as={FaCaretDown}
              ml={1}
              h="0.75rem"
              w="0.75rem"
              transition="all 0.2s ease"
              transform={isOpen ? "rotate(180deg)" : "rotate(0)"}
            />
          </Flex>
        </MenuButton>
        <MenuList
          p={0}
          m={0}
          borderRadius="1rem"
          maxWidth="100px"
          w="100px"
          overflow="hidden"
        >
          {items.map((item, index) => (
            <MenuItem
              key={index}
              py={3}
              px={4}
              borderBottom={`1px solid ${newBorder}`}
              color={textSecondary}
              _hover={{ bg: primary, color: "white" }}
              onClick={() => handleMenuItemClick(item)}
            >
              <Text fontWeight="500" fontSize="sm">
                {item}
              </Text>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default DropdownButtonTitle;
